import React from 'react';
import { bool, func, shape } from 'prop-types';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { ChainOffRounded, ChainRounded } from 'library';

// Components
import OptionSelector from './OptionSelector';

const CustomerChained = ({ data: { chained }, handleUpdateChained }) => (
  <Box
    sx={{
      borderTop: '1px solid',
      borderTopColor: 'graphic.light',
      mt: 1,
      pt: 3,
      width: '100%',
    }}
  >
    <Typography variant="h7">Do other customers need proof of transfer?</Typography>
    <RadioGroup
      aria-label="Radio Selection"
      name="options1"
      onChange={handleUpdateChained}
      value={chained ? 'true' : 'false'}
    >
      <FormControlLabel
        control={
          <Radio
            sx={{
              ml: '7px',
            }}
          />
        }
        label={
          <OptionSelector
            displayText="Customer Chain Not Required"
            icon={<ChainOffRounded sx={{ color: chained ? 'primary.main' : 'text.primary' }} />}
            selected={!chained}
          />
        }
        sx={{
          '& > .MuiFormControlLabel-label': {
            width: '100%',
          },
          bgcolor: !chained ? 'secondary.light' : 'transparent',
          border: '1px solid',
          borderColor: chained ? 'graphic.light' : 'transparent',
          borderRadius: 3,
          mb: 0,
          mt: 2,
          mx: 0,
          width: '100%',
        }}
        value="false"
      />
      <FormControlLabel
        control={
          <Radio
            sx={{
              ml: '7px',
            }}
          />
        }
        label={
          <OptionSelector
            displayText="Customer Chain Required"
            icon={<ChainRounded sx={{ color: !chained ? 'primary.main' : 'text.primary' }} />}
            selected={chained}
          />
        }
        sx={{
          '& > .MuiFormControlLabel-label': {
            width: '100%',
          },
          backgroundColor: chained ? 'secondary.light' : 'transparent',
          border: '1px solid',
          borderColor: !chained ? 'graphic.light' : 'transparent',
          borderRadius: 3,
          mb: 0,
          mt: 2,
          mx: 0,
          width: '100%',
        }}
        value="true"
      />
    </RadioGroup>
  </Box>
);

CustomerChained.propTypes = {
  data: shape({
    chained: bool,
  }),
  handleUpdateChained: func.isRequired,
};

CustomerChained.defaultProps = {
  data: false,
};

export default CustomerChained;
